import { BasicService } from "@/services/basic";
import { createGetUrlWithOptions } from "@/helpers/services";
export class AccessSchedules extends BasicService {
    constructor(axios) {
        super(axios);
        this.baseURL = "access-schedules";
    }
    async get(options) {
        try {
            const url = createGetUrlWithOptions(this.baseURL, options);
            const { data } = await this.$get(url);
            return Promise.resolve(data);
        }
        catch (error) {
            return Promise.reject(error);
        }
    }
    async add(accessSchedule) {
        try {
            await this.$post(this.baseURL, accessSchedule);
            return Promise.resolve(true);
        }
        catch (error) {
            return Promise.reject(error);
        }
    }
    async edit(accessSchedule) {
        try {
            await this.$put(`${this.baseURL}/${accessSchedule.id}`, accessSchedule);
            return Promise.resolve(true);
        }
        catch (error) {
            return Promise.reject(error);
        }
    }
    async delete(accessScheduleId) {
        try {
            await this.$delete(`${this.baseURL}/${accessScheduleId}`);
            return Promise.resolve(true);
        }
        catch (error) {
            return Promise.reject(error);
        }
    }
}
